import { WidgetsTotalModel, BusinessType } from "@interfaces/index";
import { formatAmount } from "@utils/index";

export const TotalsWidgetCard = ({
  data,
  businessType,
}: {
  data?: WidgetsTotalModel;
  businessType?: BusinessType;
}) => (
  <div className="relative flex min-h-[21rem] w-full flex-col rounded-lg bg-secondary-100 px-6 py-4 text-white-100 md:min-w-[20rem]">
    <div className="font-bold">
      <div className="flex items-center justify-between border-b border-b-white-16 pb-4">
        <p>Income</p>
        <p>{formatAmount(data?.totalIncome, "£")}</p>
      </div>
      <div className="flex items-center justify-between pt-4">
        <p>{businessType !== "landlord" && "Business "}Expenses</p>
        <p>
          {formatAmount(
            businessType === "landlord"
              ? data?.totalExpense
              : data?.totalBusiness || 0,
            "£",
          )}
        </p>
      </div>
    </div>
    <div className="mb-8 mt-auto flex flex-col gap-2 font-normal">
      {data?.mileage !== undefined &&
        ["other", "landlord"].includes(businessType || "") && (
          <div className="flex items-center justify-between">
            <p className="text-white-54">Mileage</p>
            <p>{formatAmount(data.mileage, "£")}</p>
          </div>
        )}
    </div>
    <div className="grid gap-2 font-bold">
      <p>Profit / Loss</p>
      <p className="text-400">{formatAmount(data?.totalProfit, "£")}</p>
    </div>
    <div className="absolute -left-3 top-1/2 z-[2] h-4 w-4 -translate-y-1/2 -rotate-45 rounded-sm bg-white-100" />
    <div className="absolute -right-3 top-1/2 z-[2] h-4 w-4 -translate-y-1/2 -rotate-45 rounded-sm bg-white-100" />
  </div>
);
